import type { RouteObject } from 'react-router';

import { PERMISSIONS } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { RequirePermission } from '@/features/auth';

export const packageRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.PACKAGES_READ} />,
    children: [
      {
        path: ROUTES.PACKAGES,
        lazy: async () => ({ Component: (await import('./pages/PackagesPage')).PackagesPage }),
      },
    ],
  },
];
